import * as types from "../constants/actionTypes";

import { REHYDRATE } from 'redux-persist';
import Cookies from "cookies-js";
import { getDomain } from "../helpers/Tools";
//import { BrowserRouter } from "react-router-dom";

export const ssoInitialState = {
    userDetails: {},
    userName: "",
    userEmail: "",
    isLoggedIn: false,
    verifiedLogin: false,
    exchangingToken: false,
    postLoginProcessCompleted: null,
    error: null
};


export default function ssoReducer(state = ssoInitialState, action) {
    var myDomain = getDomain();
    switch (action.type) {
        case types.START_TOKEN_EXCHANGE:
            return { ...state, exchangingToken: true };
        case types.END_TOKEN_EXCHANGE:
            return { ...state, exchangingToken: false };
        case types.USER_AUTHENTICATE:
            return { ...state, isFetching: true };
        case types.USER_AUTHENTICATE_SUCCESS:
            const userData = action.userData;
            const displayName = (userData.Givenname || userData.GivenName) + ' ' + userData.Surname;
            const epid = userData.EPID;
            const mychart = userData.MyChartID;
            //debugger;
            return {
                ...state,
                userDetails: userData,
                LogoutMessage: null,
                isLoggedIn: userData !== null && userData.access_token !== null,
                loginError: action.responseError,
                isFetching: action.isWaiting,
                primaryUser: { displayName: displayName, epid: epid, myChartId: "" + mychart }
            };
        //case types.USER_AUTHENTICATE_REFRESH:
        //    debugger;
        //    return { ...state, isFetching: true };
        case types.VERIFY_LOGIN_COMPLETED:
            return { ...state, verifiedLogin: true };
        case types.LOGOUT:
            return { ...ssoInitialState, LogoutMessage: null, verifiedLogin: state.verifiedLogin };
        case types.AJAX_CALL_ERROR:
            return { ...state, isFetching: false, error: action.error };
        case types.USER_AUTHENTICATE_FAILURE:
            return {
                ...state,
                isLoggedIn: false,
                userDetails: {},
                LogoutMessage: null,
                loginError: action.responseError,
                isFetching: false,
                error: action.errorCode
            };
        case types.SET_REDIRECT_URL:
            return { ...state, reDirectURL: action.URL };
        case types.UPDATE_PATIENT_IDS:
            const primaryUser = state.primaryUser;
            primaryUser.externalId = action;
            return { ...state, primaryUser: primaryUser };
        case types.POSTLOGIN_PROCESS_START:
            return { ...state, postLoginProcessCompleted: false };
        case types.POSTLOGIN_PROCESS_END:
            return { ...state, postLoginProcessCompleted: true };
        case types.USER_SETTINGS:
            return { ...state, userSettings: { ...state.userSettings, ...action } };
        case REHYDRATE:
            //console.log("SSO Rehydrating... state = " + JSON.stringify( state) + "  action = " + JSON.stringify( action));
            //let oRet = action.payload && action.payload.sso ? action.payload.sso : state;
            //console.log("SSO Rehydrating... returning = " + JSON.stringify( oRet)) ;
            return { ...state };
        //return oRet ;
        default:
            return { ...state };
    }
}
